import { createFileRoute } from '@tanstack/react-router';
import { DesktopAttributes } from '@/features/warehouse/DesktopAttributi';

/** Il catalogo degli attributi articolo: quali campi esistono oltre al nucleo. */
export const Route = createFileRoute('/_app/warehouse/attributes')({ component: DesktopAttributes });
